import { AssemblyStatesStepper } from 'src/components/stepper';
import { AssemblyJourneys, CodJourney } from 'src/constants/assemblyJourneys';

import { AssemblyStatesButtonGroup } from '../AssemblyStatesButtonGroup/AssemblyStatesButtonGroup';
import { AssemblyStatesDaypartDropdown } from '../assemblyStatesDaypartDropdown/AssemblyStatesDaypartDropdown';
import { AssemblyStatesProps } from './AssemblyStatesSidebar.interface';

export const AssemblyStatesSidebar = (props: AssemblyStatesProps) => {
  const {
    activeAssemblyJourney,
    setActiveAssemblyJourney,
    setCustomerState,
    customerState,
    getLayoutTitle,
    setIsCodConfirmationOpen,
  } = props;
  const handleClickStep = (journeyState: AssemblyJourneys) => {
    setActiveAssemblyJourney(journeyState);
    const shouldShowDefaultSections = journeyState === activeAssemblyJourney;
    if (shouldShowDefaultSections) {
      setActiveAssemblyJourney(undefined);
    }

    if (journeyState === CodJourney.CUSTOMER_ENTERS_DRIVE_THRU) {
      setIsCodConfirmationOpen(undefined);
    }

    if (journeyState === CodJourney.ORDER_IS_MADE) {
      setIsCodConfirmationOpen(false);
    }

    if (journeyState === CodJourney.PURCHASE_IS_CONFIRMED) {
      setIsCodConfirmationOpen(true);
    }
  };

  return (
    <>
      <AssemblyStatesDaypartDropdown
        onChangeDaypart={props?.onChangeDaypart}
        value={props?.selectedDaypartId}
      />
      <AssemblyStatesButtonGroup
        setCustomerState={setCustomerState}
        customerState={customerState}
      />

      <AssemblyStatesStepper
        activeAssemblyJourney={activeAssemblyJourney}
        onChange={handleClickStep}
        getLayoutTitle={getLayoutTitle}
      />
    </>
  );
};
